<template>
  <CChartPolarArea
    :datasets="defaultDatasets"
    :options="defaultOptions"
    :labels="defaultCategories"
  />
</template>

<script>
import { CChartPolarArea } from '@coreui/vue-chartjs'
import axios from "axios";

export default {
  name: 'CChartPolarAreaExample',
  components: {CChartPolarArea },
  props: {
    polarDataset: Array,
    categories: Array
  },
  // data () {
  //   return {
  //     progress: [],
  //     companyName: '',
  //     progressPerCategory: '',
  //     backgroundColor: [],
  //     pointBackgroundColor: [],
  //     categoryID: null
  //   }
  // },
  computed: {
    defaultDatasets: function () {
      return this.polarDataset.map((item, id) => {
        console.log('item', item)
        return {
          ...item,
          id
        }
      });
      // return [
      //   {
      //     label: this.categories,
      //     backgroundColor: this.backgroundColor,
      //     pointBackgroundColor: this.pointBackgroundColor,
      //     pointBorderColor: '#fff',
      //     pointHoverBackgroundColor: this.pointBackgroundColor,
      //     pointHoverBorderColor: this.pointBackgroundColor,
      //     data: this.progress
      //   },
      // ]
    },
    defaultOptions () {
      return {
        aspectRatio: 1.5
      }
    },
    defaultCategories: function () {
      return this.categories.map((item, id) => {
        return {
          ...item,
          id
        }
      });
    }
  },
  // methods: {
  //   getStat() {
  //     let self = this;
  //     for (let i = 0; i < self.progressPerCategory.length; i++) {
  //       console.log(i)
  //       self.progress.push(self.progressPerCategory[i].progress * 100)
  //       self.categories.push(self.progressPerCategory[i].category_id)
  //       self.colorGenerator()
  //     }
  //     console.log(self.progressPerCategory)
  //   },
  //   colorGenerator() {
  //     let self = this
  //     // this.mycolor = '#'+(Math.random()*0xFFFFFF<<0).toString(16);
  //     let r = () => Math.floor(256 * Math.random());
  //     let first = r();
  //     let second = r();
  //     let third = r();
  //     console.log(first, second, third)
  //     // self.backgroundColor = `rgba(${first}, ${second}, ${third}, 0.2)`
  //     // self.pointBackgroundColor = `rgba(${first}, ${second}, ${third}, 1)`
  //     self.backgroundColor.push(`rgba(${first}, ${second}, ${third}, 0.2)`)
  //     self.pointBackgroundColor.push(`rgba(${first}, ${second}, ${third}, 1)`)
  //   },
  //   getCategory() {
  //     let self = this;
  //     const token = localStorage.getItem("api_token")
  //     axios.get(this.$apiAdress + '/api/progress/' + self.categoryID, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //         Accept: 'application/json'
  //       }
  //     }).then(function (response) {
  //       self.result = response.data.data
  //       self.companyName = self.result.company_id
  //       self.progressPerCategory = self.result.progress_per_category
  //       console.log('result', self.result)
  //       self.getStat()
  //     }).catch(function (error) {
  //       console.log(error);
  //     });
  //   }
  // }
}
</script>
